(function () {
  var SOURCE = "baf-customer-events";
  var MESSAGE_TYPE = "dataLayerPush";
  var GTM_ID = "GTM-58GKRKRZ";
  var MAX_OBJECT_KEYS = 100;
  var MAX_ARRAY_ITEMS = 100;
  var MAX_DEPTH = 8;
  var gtmLoadScheduled = false;
  var gtmLoadStarted = false;
  var allowedEvents = {
    gtm_consent: true,
    baf_page_context: true,
    photo_upload: true,
    generate_lead: true,
    add_to_cart: true,
    begin_checkout: true,
    click_on: true
  };
  var allowedCommands = {
    consent: true,
    config: true,
    event: true,
    js: true,
    set: true
  };

  if (window.BAFGtmBridge && window.BAFGtmBridge.initialized) return;

  window.dataLayer = window.dataLayer || [];

  function isUsAutoConsentEnabled() {
    var privacy = window.BAFPrivacy || {};
    var countryCode = String(privacy.countryCode || "").toUpperCase();

    return privacy.usAutoConsent === true || countryCode === "US";
  }

  function gtag() {
    window.dataLayer.push(arguments);
  }

  window.gtag = window.gtag || gtag;

  function setConsentGlobals(consent) {
    window.analyticsAllowed = Boolean(consent.analyticsAllowed);
    window.marketingAllowed = Boolean(consent.marketingAllowed);
    window.preferencesAllowed = Boolean(consent.preferencesAllowed);
    window.saleOfDataAllowed = Boolean(consent.saleOfDataAllowed);
    window.bafConsentState = {
      analyticsAllowed: window.analyticsAllowed,
      marketingAllowed: window.marketingAllowed,
      preferencesAllowed: window.preferencesAllowed,
      saleOfDataAllowed: window.saleOfDataAllowed
    };
  }

  function isObject(value) {
    return value !== null && typeof value === "object" && !Array.isArray(value);
  }

  function sanitize(value, depth) {
    var result;
    var keys;
    var i;
    var key;
    var cleanValue;

    if (depth > MAX_DEPTH) return undefined;
    if (value === null) return null;

    if (typeof value === "string") return value.slice(0, 1000);
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return Number.isFinite(value) ? value : undefined;

    if (Array.isArray(value)) {
      result = [];
      for (i = 0; i < value.length && i < MAX_ARRAY_ITEMS; i = i + 1) {
        cleanValue = sanitize(value[i], depth + 1);
        if (cleanValue !== undefined) result.push(cleanValue);
      }
      return result;
    }

    if (!isObject(value)) return undefined;

    result = {};
    keys = Object.keys(value);
    for (i = 0; i < keys.length && i < MAX_OBJECT_KEYS; i = i + 1) {
      key = keys[i];
      if (key === "__proto__" || key === "constructor" || key === "prototype") continue;
      cleanValue = sanitize(value[key], depth + 1);
      if (cleanValue !== undefined) result[key] = cleanValue;
    }
    return result;
  }

  function isKnownPixelFrame(source) {
    var frames;
    var i;

    if (!source || !document.querySelectorAll) return false;

    try {
      frames = document.querySelectorAll('iframe[src*="/web-pixels@"][src*="/custom/web-pixel-"]');
      for (i = 0; i < frames.length; i = i + 1) {
        if (frames[i].contentWindow === source) return true;
      }
    } catch (e) {}

    return false;
  }

  function isAllowedPayload(payload) {
    if (Array.isArray(payload)) {
      return typeof payload[0] === "string" && Boolean(allowedCommands[payload[0]]);
    }

    if (!isObject(payload)) return false;
    if (payload.ecommerce === null && Object.keys(payload).length === 1) return true;
    return typeof payload.event === "string" && Boolean(allowedEvents[payload.event]);
  }

  function applyConsentGlobals(payload) {
    if (!isObject(payload) || payload.event !== "gtm_consent") return;

    setConsentGlobals({
      analyticsAllowed: payload.analyticsAllowed || payload.consent_analytics,
      marketingAllowed: payload.marketingAllowed || payload.consent_marketing,
      preferencesAllowed: payload.preferencesAllowed || payload.consent_preferences,
      saleOfDataAllowed: payload.saleOfDataAllowed || payload.consent_sale_of_data
    });
  }

  function pushPayload(payload) {
    var cleanPayload = sanitize(payload, 0);

    if (!isAllowedPayload(cleanPayload)) return;
    applyConsentGlobals(cleanPayload);
    window.dataLayer.push(cleanPayload);
    scheduleGtmLoad();
  }

  function handleMessage(event) {
    var data = event.data;

    if (!data || data.source !== SOURCE || data.type !== MESSAGE_TYPE) return;
    if (event.origin !== "null" && event.origin !== window.location.origin) return;
    if (!isKnownPixelFrame(event.source)) return;

    pushPayload(data.payload);
  }

  function getDeferredGtmDelay() {
    try {
      return window.matchMedia("(max-width: 749px), (hover: none), (pointer: coarse)").matches ? 9000 : 6000;
    } catch (e) {}

    return 7000;
  }

  function scheduleGtmLoad() {
    if (gtmLoadStarted || gtmLoadScheduled || document.getElementById("baf-gtm-bridge-script")) return;

    gtmLoadScheduled = true;

    function start() {
      if (gtmLoadStarted) return;
      loadGtm();
    }

    function scheduleAfterLoad() {
      window.setTimeout(start, getDeferredGtmDelay());
    }

    if (document.readyState === "complete") {
      scheduleAfterLoad();
      return;
    }

    window.addEventListener("load", scheduleAfterLoad, { once: true });
  }

  function loadGtm() {
    var firstScript;
    var gtmScript;

    if (gtmLoadStarted) return;
    gtmLoadStarted = true;

    if (document.getElementById("baf-gtm-bridge-script")) return;

    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js"
    });

    gtmScript = document.createElement("script");
    gtmScript.id = "baf-gtm-bridge-script";
    gtmScript.async = true;
    gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=" + encodeURIComponent(GTM_ID);

    firstScript = document.getElementsByTagName("script")[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(gtmScript, firstScript);
      return;
    }

    document.head.appendChild(gtmScript);
  }

  var defaultConsentAllowed = isUsAutoConsentEnabled();

  setConsentGlobals({
    analyticsAllowed: defaultConsentAllowed,
    marketingAllowed: defaultConsentAllowed,
    preferencesAllowed: defaultConsentAllowed,
    saleOfDataAllowed: defaultConsentAllowed
  });

  window.gtag("consent", "default", {
    ad_storage: defaultConsentAllowed ? "granted" : "denied",
    analytics_storage: defaultConsentAllowed ? "granted" : "denied",
    ad_user_data: defaultConsentAllowed ? "granted" : "denied",
    ad_personalization: defaultConsentAllowed ? "granted" : "denied",
    functionality_storage: "granted",
    security_storage: "granted",
    wait_for_update: 500
  });

  window.BAFGtmBridge = {
    initialized: true,
    containerId: GTM_ID,
    push: pushPayload
  };

  window.addEventListener("message", handleMessage);
})();
